var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_1651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5598 0.794872C9.96191 0.794872 0.559814 10.4208 0.559814 22.2949C0.559814 34.1696 9.96191 43.7949 21.5598 43.7949C33.1584 43.7949 42.5598 34.1696 42.5598 22.2949C42.5598 10.4208 33.1584 0.794872 21.5598 0.794872ZM21.5598 41.1497C11.428 41.1497 3.18481 32.6679 3.18481 22.2948C3.18481 11.9217 11.428 3.48229 21.5598 3.48229C31.6917 3.48229 39.9348 11.9218 39.9348 22.2948C39.9348 32.6678 31.6917 41.1497 21.5598 41.1497ZM29.9408 14.4279L17.6196 27.1216L12.0711 21.4409C11.5585 20.9162 10.7277 20.9162 10.2145 21.4409C9.70199 21.9657 9.70199 22.8162 10.2145 23.341L16.7107 29.9925C17.2233 30.5166 18.0541 30.5166 18.5673 29.9925C18.6263 29.9321 18.6769 29.8662 18.7228 29.7977L31.798 16.3286C32.3098 15.8038 32.3098 14.9533 31.798 14.4279C31.2848 13.9032 30.454 13.9032 29.9408 14.4279Z",
    fill: "#36B37E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_1651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 43,
    fill: "white",
    transform: "translate(0.559814 0.794872)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "resume/static/media/success.6502db556e79b3c4af4a34b1876fade4.svg";
export { ForwardRef as ReactComponent };